import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openRevokeRoamingDeviceAccessModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useRevokeRoamingDeviceAccessMenuItem = (identifier) => {
  const dispatch = useDispatch();

  return {
    id: "revoke-roaming-device",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-times" />
        <span>
          <FormattedMessage id="revoke_access" />
        </span>
      </Fragment>
    ),
    disabled: false,
    action: () => {
      dispatch(openRevokeRoamingDeviceAccessModal(identifier));
    },
  };
};

export const RevokeRoamingDeviceAccessDropdownItem = ({
  identifier,
  ...props
}) => {
  const { id, content, disabled, action } =
    useRevokeRoamingDeviceAccessMenuItem(identifier);

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const RevokeRoamingDeviceAccessModalItem = ({ identifier }) => {
  const { id, content, disabled, action } =
    useRevokeRoamingDeviceAccessMenuItem(identifier);

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
